<template>
  <ValidationProvider
      v-slot="{ errors, classes}"
      :class="$attrs.class"
      :mode="customValidate"
      :rules="rules"
      class="form-group w-full" tag="div"
  >
    <label v-if="label" :class="labelClass" class="block text-base font-normal mb-1">
      {{ label }}
      <b v-if="isRequired" class="ml-1 text-red-600 font-bold">*</b>
    </label>
    <div class="relative input-group">
      <LSelect
          v-model="dropdownValue"
          :absolute-class="absoluteClass"
          :alwaysShowMenu="alwaysShowMenu"
          :close-on-select="closeOnSelect"
          :disabled="disabled"
          :hidden-input="hiddenInput"
          :loading="isLoading"
          :local-search="!search"
          :multiple="multiple"
          :options="items"
          :placeholder="placeholder"
          @onOpen="onOpen"
          @onScrollEnd="onScrollEnd"
          @onSearchChange="onSearch"
          v-on="$listeners"
      >
        <template v-for="(_,slotName) in $scopedSlots" v-slot:[slotName]="{data}">
          <slot :name="slotName" v-bind:data="data"/>
        </template>
        <template v-slot:option-content="{data}">
          <slot name="option-content" v-bind:data="data"/>
        </template>
      </LSelect>
    </div>
  </ValidationProvider>
</template>

<script>
import LSelect, {EVENT} from "@/components/select/LSelect/LSelect.vue";
import {$debounce, convertAccentedLettersToUnsigned, unique} from "@/helpers/helpers";

export default {
  name: "AsyncLSelect",
  components: {LSelect},
  mixins: [LSelect],
  props: {
    fieldLabel: {
      type: String,
      default: "text"
    },
    label: String,
    returnObj: {
      type: Boolean,
      default: false,
    },
    search: {
      type: [Function, undefined],
      default: null,
    },
    placeholder: String,
    rules: String,
    params: {
      type: Object,
      default: () => {
      }
    },
    hintClass: [String, Array],
    hint: {
      type: String,
      default: ""
    },
    labelClass: {
      type: String,
      default: "font-light"
    },
    expandCheckItem: {
      type: Boolean,
      default: false,
    },
    alwaysShowMenu: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: 8,
    },
    hiddenInput: {
      type: Boolean,
      default: false,
    },
    absoluteClass:{
      type: Boolean,
      default: true,
    }
  },
  computed: {
    isRequired() {
      return this.required || this.rules?.search("required") > -1;
    },
    page() {
      const totalItems = this.items.length;
      return totalItems === 0 ? 0 : Math.ceil(totalItems / this.limit);
    },
  },
  data: () => ({
    items: [],
    hasMore: true,
    isFirstTime: true,
    isLoading: false,
    keyword: "",
  }),
  watch: {
    options: {
      handler(val) {
        if (val && val.length) {
          if (this.expandCheckItem) {
            this.items = this.expandSelected(val, this.dropdownValue);
          } else
            this.items = [...val];
        }
      },
      immediate: true
    },
    params(val) {
      // this.isFirstTime = true;
    },
  },
  methods: {
    customValidate() {
      return {on: ["search:blur", "input"]};
    },
    async onOpen() {
      if (this.search && this.isFirstTime) {
        this.items = [];
        this.hasMore = true;
        this.keyword = "";
        await this.fetchOptions();

        // this.isFirstTime = false;
      }
    },
    async onSearch(keyword) {
      if (!this.search) return;

      if (this.keyword !== keyword) {
        this.items = [];
        this.hasMore = true;
        this.keyword = keyword;
      }

      await $debounce(300);
      await this.fetchOptions();
    },
    async fetchOptions() {

      if (!this.hasMore || this.isLoading) return;
      this.isLoading = true;
      const response = await this.search({
        keyword: this.keyword,
        take: this.limit,
        page: this.page,
        ...this.params,
      });
      this.isLoading = false;
      if (response.error) return;
      this.hasMore = response.data.data.length === this.limit;
      let tempItem = unique([...this.items, ...response.data.data]);

      if (this.expandCheckItem) {
        tempItem = this.expandSelected(tempItem, this.dropdownValue);
      }
      this.items = tempItem;
    },
    async onScrollEnd() {
      if (!this.search) return;
      await this.fetchOptions();
    },
    expandSelected(options, ids) {
      options.map(x => {
        if ((this.multiple && ids.includes(x.id)) || x.id === ids) {
          x.expand = true;
        }

        if (x?.children?.length) {
          this.expandSelected(x.children, ids)
        }
      })
      return options;
    },
  },
  created() {
    this.isFirstTime = true;
  }
}
</script>

<style scoped>

</style>
